<template>
<div>
  <MinappBannerAdvert class="mb16" />
  <pack>

    <!-- 顶部插件信息 -->
    <div class="ext-layout__top">
      <slot name="top">
        <div class="ext-infos">
          <div class="icon" :style="`border-color:${borderColor}`"><img :src="icon"></div>

          <div class="info">
            <div class="title">
              <span>
                <slot name="title">{{ title }}</slot>
              </span>
              <slot name="title-other"></slot>
            </div>
            <div class="desc">
              <slot name="desc">{{ desc }}</slot>
            </div>
            <div class="pidManage">
              <slot name="pidManage"></slot>
            </div>
            <div class="buy">
              <slot name="top-buy">
                <zt-button type="primary" size="medium" width="140px" @click="$emit('buttonClick', $event)">立即购买</zt-button>
              </slot>
            </div>
          </div>
        </div>
      </slot>
    </div>

    <!-- 内容 -->
    <div class="ext-layout__content">
      <slot></slot>
    </div>
  </pack>
</div>
</template>

<script>
import { MinappBannerAdvert } from '@/components/Adverts'
import { string } from 'vue-types'
export default {
  name: 'ExtLayout',
  components:{ MinappBannerAdvert },
  props: {
    icon: String,
    title: String,
    desc: String,
    borderColor:String,
  },
  data: () => ({
    
  }),
}
</script>

<style lang="scss" scoped>
.pack {
  padding: 0;
}

.ext-layout__top,
.ext-layout__content {
  padding: 32px;
}

.ext-layout__content {
  border-top: 1px solid $theme-border3;
}

.ext-infos {
  display: flex;

  .icon {
    border: 6px solid #9FF7D0;
    border-radius: 18px;
    flex: 0 0 112px;
    width: 112px;
    height: 112px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 24px;

    img {
      width: 86px;
      // max-width: 100%;
      // max-height: 100%;
      display: block;
    }
  }

  .title {
    display: flex;
    align-items: baseline;

    span {
      font-weight: bold;
      font-size: 18px;
      display: block;
      margin-right: 12px;
      line-height: 25px;
    }
  }

  .desc {
    margin-top: 8px;
    color: $theme-textnormal;
    font-size: 14px;
    line-height: 20px;
  }
  .pidManage {
    margin-top: 8px;
    color: #FE7A42;
    font-size: 16px;
    line-height: 20px;
  }
  .buy {
    margin-top: 10px;
  }
}
</style>
